import React, { useMemo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import OfferList from 'components/OfferList/v2/OfferList'
import { getPlural } from 'lib/pluralize'

import { OFFER_TYPE_LAST_MINUTE } from 'constants/offer'
import Heading from 'components/Luxkit/Typography/Heading'
import Subtitle from 'components/Luxkit/Typography/Subtitle'
import { useOfferList } from 'hooks/Offers/useOfferList'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Typography from 'components/Luxkit/Typography/Typography'
import LastMinuteBanner from '../TypesPage/LastMinuteEscapes/LastMinuteBanner'

const SpacedOfferList = styled(OfferList)`
  margin-top: ${rem(32)};
`

interface Props {
  offerListFilters: App.OfferListFilters;
}

const types: App.OfferType[] = [OFFER_TYPE_LAST_MINUTE]
function LastMinuteYAMLOfferList(props: Props) {
  const { offerListFilters } = props

  const filters = useMemo(() => {
    return {
      ...offerListFilters,
      offerTypes: types,
    }
  }, [offerListFilters])
  const [list] = useOfferList(filters)
  const count = list.offerIds.length

  if (count === 0) {
    return null
  }

  return <VerticalSpacer gap={20}>
    <Heading variant="heading5" align="center">You may also like our</Heading>
    <Typography align="center">
      <LastMinuteBanner width={rem(320)} />
    </Typography>
    <Subtitle variant="subtitle2" align="center">
      We have {count} last minute {getPlural('offer', count)} available in your desired destination
    </Subtitle>
    <SpacedOfferList
      filters={filters}
    />
  </VerticalSpacer>
}

export default LastMinuteYAMLOfferList
